// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Card, CardContent, CircularProgress, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import "./support.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SupportUserAPI, SupportUserTickets } from "api-services";
import { useMaterialUIController } from "context";
import { ShowSuccessMessage } from "helpers";
import MDTypography from "components/MDTypography";
import Tickets from "./tickets";

function SupportUser() {
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const [text, setText] = useState("");
  const [subject, setSubject] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [userSupportItem, setUserSupportItem] = useState();

  const loading = useSelector((state) => state.products.loading);
  const userData = useSelector((state) => state.authentication.user_data);

  // Upload File
  const [file, setFile] = useState();

  const dispatchData = useDispatch();

  const handleValidation = () => {
    let tempErrors = {};
    let isValid = true;

    if (subject.length <= 0) {
      tempErrors["subject"] = true;
      isValid = false;
    }

    if (subject.length > 100) {
      tempErrors["subject_length"] = true;
      isValid = false;
    }
    if (text.length <= 0) {
      tempErrors["text"] = true;
      isValid = false;
    }

    if (text.length > 1000) {
      tempErrors["text_length"] = true;
      isValid = false;
    }
    if (file) {
      if (file?.size > 10485760) {
        tempErrors["file_size"] = true;
        isValid = false;
      }
    }
    if (
      file?.type == "image/png" ||
      file?.type == "image/jpg" ||
      file?.type == "image/jpeg" ||
      file?.type == "application/zip" ||
      file?.type ==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      file?.type == "application/json" ||
      file?.type == "image/jpg"
    ) {
      // Do Nothing
    } else {
      //execute logic
      if (file) {
        tempErrors["file_type"] = true;
        isValid = false;
      }
    }
    setErrors({ ...tempErrors });
    return isValid;
  };

  useEffect(() => {
    SupportUserTickets(dispatchData, successAction, () => {});
  }, []);

  const successAction = (res) => {
    res.data.map((item) => {
      setUserSupportItem(item);
    });
  };

  const handleSubmit = () => {
    const data = new FormData();
    data.append("file", file);
    data.append("FileName", file?.name);
    data.append("subject", subject);
    data.append("message", text);
    data.append("customerID", userData?.customer?.id);
    data.append("userEmail", userData?.customer?.email);
    data.append("companyName", userData?.customer?.companyName);

    //   for (var pair of data.entries()) {
    //     console.log(pair[0]+ ', ' + pair[1]);
    // }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    if (handleValidation()) {
      SupportUserAPI(
        dispatchData,
        data,
        config,
        success,
        setShowErrorMessage,
        clearFields
      );
    }
  };

  const success = () => {
    ShowSuccessMessage(
      dispatch,
      "Message Sent",
      "Thanks for reaching out! We'll get back to you soon."
    );
    SupportUserTickets(dispatchData, successAction, () => {});
  };
  const clearFields = () => {
    setText("");
    setSubject("");
    setFile("");
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={5}>
        <Card className="pattren-gp">
          <CardContent>
            <MDBox>
              <Grid container spacing={3}>
                <Grid item xs={10} lg={4} fullwidth>
                  <MDBox>
                    <MDTypography
                      variant="h6"
                      fontWeight="medium"
                      fontFamily="inherit"
                      lineHeight={3}
                    >
                      Get In Touch
                    </MDTypography>
                  </MDBox>
                  <MDBox mb={2}>
                    <TextField
                      className="outlined-basic-subject"
                      label="Subject*"
                      variant="outlined"
                      value={subject}
                      onChange={(event) => {
                        setSubject(event.target.value);
                      }}
                    />
                    {errors?.subject && (
                      <p className="text-red">Subject cannot be empty.</p>
                    )}
                    {errors?.subject_length && (
                      <p className="text-red">
                        Subject cannot be more than 100 characters.
                      </p>
                    )}
                  </MDBox>
                  <TextareaAutosize
                    className={darkMode ? "qoute-tarea" : "qoute-tarea white"}
                    color="inherit"
                    aria-label="minimum height"
                    minRows={3}
                    placeholder="Your Message*"
                    value={text}
                    maxlength="1000"
                    onChange={(event) => {
                      setText(event.target.value);
                    }}
                  />
                  <MDTypography variant="body1" sx={{ fontSize: "12px" }}>
                    {text.length}/1000 (maximum characters)
                  </MDTypography>
                  {errors?.text && (
                    <p className="text-red">Message cannot be empty.</p>
                  )}
                  {errors?.text_length && (
                    <MDTypography className="text-red" color="error">
                      Message cannot be more than 1000 characters.
                    </MDTypography>
                  )}
                  <MDBox mt={2} mb={1}>
                    {showErrorMessage != "" && (
                      <MDTypography className="text-red" color="error">
                        {showErrorMessage}
                      </MDTypography>
                    )}
                    <MDBox sx={{ display: "flex", alignItems: "baseline" }}>
                      <MDButton
                        variant="contained"
                        color="secondary"
                        component="label"
                        sx={{ marginRight: "15px", marginBottom: "8px" }}
                      >
                        Choose File
                        <input
                          hidden
                          type="file"
                          onChange={(e) => setFile(e.target.files[0])}
                        />
                      </MDButton>
                      <MDTypography sx={{ fontSize: "12px" }}>
                        {file && `${file.name}`}
                      </MDTypography>
                    </MDBox>
                    {errors?.file_size ? (
                      <MDTypography
                        sx={{ color: "red" }}
                        className="text-red mb-2"
                      >
                        File size cannot exceed more than 10MB
                      </MDTypography>
                    ) : (
                      <MDTypography
                        sx={{
                          color: "#c9cbd1",
                          fontSize: "10px!important",
                          marginBottom: "0px!important",
                        }}
                        className="text-red mb-2"
                      >
                        Max file size: 10MB
                      </MDTypography>
                    )}
                    {errors?.file_type ? (
                      <MDTypography
                        sx={{ color: "red" }}
                        className="text-red mb-2"
                      >
                        Allowed Formats JPG, PNG, Docx, JSON, ZIP
                      </MDTypography>
                    ) : (
                      <MDTypography
                        sx={{ color: "#c9cbd1", fontSize: "10px!important" }}
                        className="text-red mb-2"
                      >
                        File Formats: JPG, PNG, Docx, JSON, ZIP
                      </MDTypography>
                    )}
                    <MDButton
                      variant="gradient"
                      color="info"
                      sx={{ minWidth: 200, background: "#022DEC", backgroundImage: "none !important" }}
                      onClick={() => handleSubmit()}
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Send Message"
                      )}
                    </MDButton>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          </CardContent>
        </Card>
        {/* Tickets */}
        {userSupportItem ? <Tickets /> : ""}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SupportUser;
